import AnimatedPageLoader from "@Icons/AnimatedPageLoader";
import LoaderIcon from "@Icons/LoaderIcon";
import useIsDesktop from "hooks/useIsDesktop";
import useWhitelabel from "hooks/useWhitelabel";

const FullPageLoader = ({ height = "100vh", width = "100%", showAnimated = false }) => {
  const isDesktop = useIsDesktop();
  const { isWhitelabel, whitelabelColors } = useWhitelabel();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height,
        width,
      }}
    >
      {isDesktop && !showAnimated ? (
        <LoaderIcon {...(isWhitelabel && { fill: whitelabelColors?.accessible_brand_color })} />
      ) : (
        <AnimatedPageLoader />
      )}
    </div>
  );
};

export default FullPageLoader;
